// extracted by mini-css-extract-plugin
export default {"header":"ModalCommonContent_header__6sMbU","title":"ModalCommonContent_title__M7mJA","buttonField":"ModalCommonContent_buttonField__CAguR"};